export default __webpack_public_path__ + "static/integrateRight-93928c64a14591fdf0945687c20a23ee.png";